import { Inject, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SearchRepository } from '@core/services/repositories/search.repository';
import * as leaflet from 'leaflet'
import { WINDOW } from '../../app.module';
import { isPlatformBrowser } from '@angular/common';
@Injectable({
 providedIn: 'root',
})
export class MapService {
 constructor(  @Inject(WINDOW) private window: Window,
   @Inject(PLATFORM_ID) private platformId: Object) {
   if (isPlatformBrowser(this.platformId)) {
     this.loadStyle();
    }
 }

 private mapInstance!: any;

 searchRepo = inject(SearchRepository);


 async initLeafletMap(containerId: string, lat: number, lng: number, zoom: number) {
   if (!isPlatformBrowser(this.platformId)) return;

   const leaflet = await import('leaflet');

   const map = leaflet.map(containerId, {
     center: [lat, lng],
     zoom: zoom,
   });

   leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
     attribution: '&copy; OpenStreetMap contributors',
   }).addTo(map);

   this.mapInstance = map;
   return map;
  }

  async initNeshanMap(containerId: string, lat: number, lng: number, zoom: number, apiKey: string): Promise<any> {
    const neshanL = await this.loadNeshanSDK();

    const map = new neshanL.Map(containerId, {
      key: apiKey,
      maptype: 'neshan',
      poi: false,
      traffic: false,
      center: [lat, lng],
      zoom: zoom,
    });

    this.mapInstance = map;
    return map;
  }

  getMapInstance() {
    return this.mapInstance;
  }


 loadNeshanSDK(): Promise<any> {
  return new Promise((resolve, reject) => {
   if ((this.window as any).neshanL) {
     return resolve((this.window as any).neshanL);
   }
   const script = document.createElement('script');
   script.src = 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.js';
   script.onload = () => {
    (this.window as any).neshanL = (this.window as any).L;
    resolve((this.window as any).neshanL);
   };
   script.onerror = reject;
   document.body.appendChild(script);
  });
 }

 loadStyle() {
   if (!isPlatformBrowser(this.platformId)) return;
    const id = 'map-style';
    if (document.getElementById(id)) return;
  
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = 'https://static.neshan.org/sdk/leaflet/v1.9.4/neshan-sdk/v1.0.8/index.css';
    document.head.appendChild(link);
  }
}
